<main class="maintenance">
  <section class="maintenance__card" aria-labelledby="maintenance-title">
    <div class="maintenance__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" role="img">
        <path
          d="M14.7 6.3a4 4 0 0 0-5-5L12 3.6 9.6 6 7.3 3.7a4 4 0 0 0 5 5l-8.8 8.8a2.1 2.1 0 0 0 3 3l8.8-8.8a4 4 0 0 0 5-5L18 5l-2.4 2.4-2.3-2.3L15.7 3z"
        />
      </svg>
    </div>

    <p class="maintenance__eyebrow">Manutenção programada</p>
    <h1 id="maintenance-title">Voltaremos em breve</h1>
    <p class="maintenance__message">
      Estamos realizando melhorias em nossos servidores. Durante esse período,
      o sistema ficará temporariamente indisponível.
    </p>
    <p class="maintenance__hint">
      Agradecemos a compreensão. Tente acessar novamente mais tarde.
    </p>
  </section>
</main>
